export default __webpack_public_path__ + "static/media/landing-desktop-06.77bb6ece.png";